const Roles = [
    { value: "admin", text: "Administrator" },
    { value: "user", text: "User" },
];

export default Roles;
